const APP_SECTION_SEPARATORS = {
    UNDERSCORE: '_',
};

const APP_SECTION_PREFIXES = {
    HIGHLIGHTS: 'highlights',
};

/**
 * Parses app section into section and parameter
 * Examples:
 *   'highlights_newProducts' => { section: 'highlights', param: 'newProducts' }
 *   'section_link' => { section: 'section_link', param: null }
 */
const parseAppSection = (appSection) => {
    if (!appSection || typeof appSection !== 'string') {
        return {section: null, param: null};
    }

    const normalizedCode = appSection.toLowerCase().trim();
    const underscoreParts = normalizedCode.split(APP_SECTION_SEPARATORS.UNDERSCORE);

    if (underscoreParts.length >= 2) {
        const [section, ...paramParts] = underscoreParts;

        return {
            section,
            param: paramParts.join(APP_SECTION_SEPARATORS.UNDERSCORE),
        };
    }

    // No separator found, return as section only
    return {section: normalizedCode, param: null};
};

const isHighlightsAppSection = (appSection) => {
    const {section} = parseAppSection(appSection);

    return section?.toLowerCase() === APP_SECTION_PREFIXES.HIGHLIGHTS;
};

const getHighlightsTagFromAppSection = (appSection) => {
    const {section, param} = parseAppSection(appSection);

    if (section === APP_SECTION_PREFIXES.HIGHLIGHTS && param) {
        return param;
    }

    return null;
};

export default {
    parseAppSection,
    isHighlightsAppSection,
    getHighlightsTagFromAppSection,
};
